"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileSubmoduleNavigation = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _isEmpty = _interopRequireDefault(require("lodash/fp/isEmpty"));
var _modulePropTypes = _interopRequireDefault(require("./modulePropTypes"));
var _MobileHeaderModal = require("./MobileHeaderModal");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var MobileSubmoduleNavigation = function MobileSubmoduleNavigation(props) {
  var navItems = props.navItems,
    label = props.label,
    className = props.className;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  var handleToggleNavigation = function handleToggleNavigation() {
    return setIsShown(!isShown);
  };
  var hasNavItems = !(0, _isEmpty["default"])(navItems);
  var classes = (0, _classnames["default"])('MobileSubmoduleNavigation', 'display-flex gap-10 align-items-center', 'padding-x-10', 'cursor-pointer', className);
  var labelClasses = (0, _classnames["default"])(hasNavItems ? 'text-size-12 text-color-dark line-height-14' : 'text-size-16 line-height-16 text-color-darkest text-medium text-uppercase', 'width-100pct ellipsis-1');
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: classes,
    onClick: handleToggleNavigation
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex-1-1 display-flex flex-column align-items-center width-0"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: labelClasses
  }, label), /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-medium width-100pct"
  }, navItems.map(function (navItem) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: navItem.key,
      className: "ellipsis-1"
    }, /*#__PURE__*/_react["default"].cloneElement(navItem.route, {
      className: 'text-size-16 line-height-16 text-color-darkest text-decoration-none',
      onClick: function onClick(event) {
        return event.preventDefault();
      }
    }));
  }))), hasNavItems && /*#__PURE__*/_react["default"].createElement("div", {
    className: "text-size-16 text-color-dark"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "rioglyph rioglyph-chevron-down"
  })), hasNavItems && /*#__PURE__*/_react["default"].createElement(_MobileHeaderModal.MobileHeaderModal, {
    show: isShown
  }, navItems.map(function (navItem) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: navItem.key,
      className: "margin-y-15 font-size-20"
    }, /*#__PURE__*/_react["default"].cloneElement(navItem.route, {
      className: 'text-size-20 text-color-darker'
    }));
  })));
};
exports.MobileSubmoduleNavigation = MobileSubmoduleNavigation;
MobileSubmoduleNavigation.defaultProps = {
  navItems: []
};
MobileSubmoduleNavigation.propTypes = {
  label: _propTypes["default"].node,
  navItems: _propTypes["default"].arrayOf(_modulePropTypes["default"]),
  className: _propTypes["default"].string
};